module.exports = __webpack_public_path__ + "assets/noImg.fbf528b4.svg";